export const withLeadingZero = n => (n < 10 ? "0" : "") + n;

export const millisToFormatedDate = milliseconds => {
  const date = new Date(milliseconds);
  const h = withLeadingZero(date.getUTCHours());
  const m = withLeadingZero(date.getUTCMinutes());
  const s = withLeadingZero(date.getUTCSeconds());
  const t = `${h}:${m}:${s} - ${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
  return t;
};

export default millisToFormatedDate;
